const openMenu = (state, action) => {
    state.isOpen = true;
};
const closeMenu = (state, action) => {
    state.isOpen = false;
};
const showMenu = (state, action) => {
    state.isShown = true;
};
const hideMenu = (state, action) => {
    state.isShown = false;
};

export { openMenu, closeMenu, showMenu, hideMenu };
